import {
  getArweaveGatewayCandidates as getSharedArweaveGatewayCandidates,
  isArweaveGatewayUrl as isSharedArweaveGatewayUrl,
} from '../shared/arweave/publicArweaveGateway';
import { ARWEAVE_PUBLIC_GATEWAY_HOSTS } from '../lib/config';

export function isArweaveGatewayUrl(rawUrl: string): boolean {
  return isSharedArweaveGatewayUrl(rawUrl, ARWEAVE_PUBLIC_GATEWAY_HOSTS);
}

export function getArweaveGatewayCandidates(rawUrl: string): string[] {
  return getSharedArweaveGatewayCandidates(
    rawUrl,
    ARWEAVE_PUBLIC_GATEWAY_HOSTS,
  );
}
